import { useApiQuery } from 'grabbitbot-legacy-ui'
import { paymentReads } from '../../api/fee'
import { PageTitle, QueryState } from '../../components/common'
import { BillingDetails, PaymentMethodSummary } from '../../components/payment'
import { useProject } from '../../layout/projectContext'
import { useEmailParam } from '../../lib/useEmailParam'
import { hasMethod, paymentMethodTone } from '../../lib/paymentHelpers'
import { AdminUserLocalMenu } from './AdminUserLocalMenu'

/** Port of `AdminUserPaymentInfoComponent` (`…/admin/users/paymentinfo?email=`):
 * an end-user's saved card and billing address, read-only. */
export function AdminUserPaymentInfoPage() {
  const { projectId, project } = useProject()
  const email = useEmailParam()
  const pm = useApiQuery(() => (email ? paymentReads.methodOfUser(projectId, email) : Promise.resolve(null)), [projectId, email])
  const billing = useApiQuery(() => (email ? paymentReads.billingOfUser(projectId, email) : Promise.resolve(null)), [projectId, email])
  return (
    <div className="portal-card">
      <PageTitle title={`Payment info — ${project.name}`}>
        <AdminUserLocalMenu email={email} title="Payment info" />
      </PageTitle>
      {!email && <p className="portal-text-muted">Pick a user from the menu above.</p>}
      {email && (
        <div className="portal-grid-2">
          <QueryState loading={pm.loading} error={pm.error}>
            {pm.data &&
              (hasMethod(pm.data) ? (
                <div className={`fs-panel ${paymentMethodTone(pm.data)}`}>
                  <h3>Payment method</h3>
                  <PaymentMethodSummary pm={pm.data} />
                </div>
              ) : (
                <div className="fs-panel fs-panel--warning">
                  <h3>Payment method</h3>
                  <p>{pm.data.createdAt ? 'Payment method removed' : 'Payment method not set'}</p>
                </div>
              ))}
          </QueryState>
          <QueryState loading={billing.loading} error={billing.error}>
            {billing.data && (
              <div className="fs-panel">
                <h3>Billing information</h3>
                <BillingDetails billing={billing.data} />
              </div>
            )}
          </QueryState>
        </div>
      )}
    </div>
  )
}
